import { ContentUtils } from 'braft-utils';

export default ContentUtils;


// WEBPACK FOOTER //
// ./src/components/content-utils/index.tsx